import { render, staticRenderFns } from "./webview.vue?vue&type=template&id=a2fc0674&scoped=true"
import script from "./webview.vue?vue&type=script&lang=js"
export * from "./webview.vue?vue&type=script&lang=js"
import style0 from "./webview.vue?vue&type=style&index=0&id=a2fc0674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc0674",
  null
  
)

export default component.exports